import { commonMetaData } from '~/store/_helpers/common-helper'
import grpcClient from '@/grpc/grpc-client'

export const USER_ACTION = Object.freeze({
  VIEW_BUSINESS_TOP: 'view_business_top',
  VIEW_BUSINESS_TOP_NOLOGIN: 'view_business_top_nologin'
})

export const state = () => ({
  corporation: {},
  heroAreasList: [],
  watchedServicesList: [],
  myFavoriteServicesList: [],
  selectedMasterCategoryServicesList: [],
  otherMasterCategoryServicesList: [],
  popularUsersList: [],
  popularProServicesList: [],
  businessCategoriesList: [],
  newsList: []
})

export const getters = {}

export const actions = {
  async fetchContent({ rootState, commit }, params = {}) {
    const requestModule = await import('~/stub/apigateway/business/business_top_pb')
    const methodModule = await import('~/stub/apigateway/business/business_top_pb_service')
    const metadata = commonMetaData(rootState)
    const request = new requestModule.GetTopContentRequest()
    if (params.browsingHistory) {
      request.setWatchedServiceIds(params.browsingHistory)
    }
    if (params.userAction) {
      request.setUserAction(params.userAction)
    }
    request.setDetailJson(params.detailJson)
    const response = await grpcClient({
      method: methodModule.BusinessTopService.GetTopContent,
      request,
      metadata
    })
    commit('SAVE_CONTENT', response)
  }
}

export const mutations = {
  SAVE_CONTENT(state, data) {
    Object.assign(state, data)
  }
}
